/**
 * Edit Distributor Form Schema
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

const MIN_NUMBER = 1000000000
const MAX_NUMBER = 9999999999

export const EditDistributorFormSchema = z.object({
  distributorNumber: z
    .number()
    .gte(MIN_NUMBER)
    .lte(MAX_NUMBER),
  distributorName: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name cannot exceed 100 characters'),
})

export type EditDistributorFormData = z.infer<typeof EditDistributorFormSchema>

export function transformToApiRequest(formData: EditDistributorFormData) {
  return {
    distributorNumber: formData.distributorNumber,
    distributorName: formData.distributorName,
  }
}
